export const CONFIRM_BUTTON_COLOR_TYPE = {
  ERROR: 'error',
  INHERIT: 'inherit',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
} as const;
